import React from 'react';
import { Route, Redirect } from "react-router-dom";
import PropTypes from 'prop-types';

const PrivateRouteWithLayout = props => {
  const { layout: Layout, component: Component, ...rest } = props;
  let isAuthenticated = false;
  const token = JSON.parse(localStorage.getItem('token'));
  if (token) {
    isAuthenticated = true
  }
  return (
    <Route
      {...rest}
      render={matchProps => isAuthenticated ? (
        <Layout>
          <Component {...matchProps} />
        </Layout>
      ) : (
        <Redirect
              to={{
                pathname: "/sign-in",
                state: { from: props.location }
              }}
            />
      )}
    />
  );
};

PrivateRouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.string
};

export default PrivateRouteWithLayout;
